import { Button, RightArrowIcon, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

export interface TestimonialCardFooterProps {
  readonly nameMsgKey: MessageKey | undefined;
  readonly name: string | undefined;
  readonly company: string | undefined;
  readonly action:
    | {
        link: string;
        messageKey: MessageKey;
      }
    | undefined;
}

const TestimonialCardFooter = ({
  nameMsgKey,
  name,
  company,
  action,
}: TestimonialCardFooterProps) => {
  const t = useTranslations();
  return (
    <>
      {(nameMsgKey ?? name) && (
        <TypographyV3
          className="text-base font-normal xxl:text-heading-xs"
          color="inherit"
          data-cy={`testimonial-card-footer-name-${nameMsgKey ?? name}`}
          Element="div"
        >
          {nameMsgKey ? t(nameMsgKey) : name}
        </TypographyV3>
      )}
      {company && (
        <TypographyV3
          data-cy={`testimonial-card-footer-company-${company}`}
          className="text-sm"
        >
          {company}
        </TypographyV3>
      )}
      {action && (
        <Button
          className="text-inherit sm:mt-1 md:mt-6"
          data-cy={`testimonial-card-footer-action-link-${action.messageKey}`}
          endIcon={<RightArrowIcon width="18" />}
          href={action.link}
          link
          size="none"
          target="_blank"
          variant="body-link"
        >
          <span className="underline">{t(action.messageKey)}</span>
        </Button>
      )}
    </>
  );
};
export default TestimonialCardFooter;
